import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { intakeQuestionnaireActions } from '../../../../../../../store';

import type { AppDispatch, RootState } from '../../../../../../../store';

export default function useIntakeFamilyCulturalConsideration() {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { intakeQuestionnaireId } = useParams<'intakeQuestionnaireId'>();
  const culturalConsideration = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.intakeQuestionnaireDetails?.family?.cultural_consideration ?? '',
  );
  const savedValueRef = useRef(culturalConsideration);
  const saveQueueRef = useRef<Promise<void>>(Promise.resolve());

  useEffect(() => {
    savedValueRef.current = culturalConsideration;
  }, [culturalConsideration]);

  const save = useCallback(
    (value: string) => {
      const performSave = async () => {
        if (!intakeQuestionnaireId || value === savedValueRef.current) return;
        const result = await dispatch(
          intakeQuestionnaireActions.updateIntakeFamily({
            intakeQuestionnaireId,
            data: { cultural_consideration: value },
            getAccessTokenSilently,
          }),
        );
        if (intakeQuestionnaireActions.updateIntakeFamily.fulfilled.match(result)) {
          savedValueRef.current = value;
        }
      };

      // Serialized so an earlier save's response can't land after a later one and revert the field.
      const queuedSave = saveQueueRef.current.then(performSave);
      saveQueueRef.current = queuedSave;
      return queuedSave;
    },
    [dispatch, getAccessTokenSilently, intakeQuestionnaireId],
  );

  return { culturalConsideration, save };
}
